<style scoped>
@import "./WbsRechner.css";
</style>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Headerbox from "../components/Headerbox.vue";
import { Person } from '../interfaces/persons';
import { Frequency } from "../interfaces/frequency";
import { Type } from "../interfaces/type";
import { WBS } from "../interfaces/wbs";
import { WbsService } from "../service/wbsService";
import { Income } from "@/interfaces/incomes";


export default defineComponent({
  name: "WBS-Rechner",
  components: {
    Headerbox,
  },
  data() {
    return {
      personanzahl: 1,
      persons: [{ index: 1, incomes: [] as Income[], totalincome: 0 }],
      wbs: { wbsGranted: "Keinen", difference: 0, percent: 0, yearlyAmount: 0, yearlyAmountMax: 0 } as WBS,
      wbsResult: false,
      types: [] as Type[],
      freq: [] as Frequency[],
    };
  },
  created() {
    const wbsService = new WbsService();
    wbsService.getTypes().then((types) => {
      this.types = types;
    });
    wbsService.getFrequencies().then((freqs) => {
      this.freq = freqs;
    });
  },
  methods: {
    updatePersonenanzahl(event: Event) {
      this.refreshPeople(this.personanzahl);
    },

    refreshPeople(personenanzahl: number) {
      if (personenanzahl > this.persons.length) {
        let anzahl = personenanzahl - this.persons.length;
        for (let i = 1; i <= anzahl; i++) {
          this.addPerson();
        }
      }

      if (personenanzahl < this.persons.length) {
        let anzahl = this.persons.length - personenanzahl;
        for (let i = 1; i <= anzahl; i++) {
          this.deletePerson(this.persons.length);
        }
      }
    },

    addPerson() {
      const newPerson: Person = {
        index: this.getHighestIndex(this.persons) + 1,
        incomes: [],
        totalincome: 0
      };
      this.persons.push(newPerson)
    },

    deletePerson(index: Number) {
      this.persons = this.persons.filter(person => person.index !== index);
    },
    getHighestIndex(arr: any[]) {
      let highestIndex = 0;
      if (typeof arr === "undefined") {
        return highestIndex;
      }
      for (const item of arr) {
        if (item.index > highestIndex) {
          highestIndex = item.index;
        }
      }
      return highestIndex;
    },


    addIncome(index: number) {
      const newincome = {
        index: this.getHighestIndex(this.persons[index - 1].incomes) + 1,
        amount: 0,
        frequency: 0,
        advertisingCosts: 0,
        type: 0
      };
      const persons = this.persons;
      const person = persons[index - 1];

      person.incomes = [...person.incomes, newincome];

    },

    deleteIncome(pindex: number, iindex: number) {
      console.log(`${pindex} - ${iindex}`);
      const persons = [...this.persons];
      const person = persons[pindex];

      person.incomes.splice(iindex, 1);

      this.persons = persons;

      this.calculateTotalIncome(pindex);
    },

    calculateTotalIncome(personindex: number) {
      let totalIncome = 0;
      for (const income of this.persons[personindex].incomes) {
        totalIncome += ((income.frequency * income.amount) - income.advertisingCosts);
      }
      this.persons[personindex].totalincome = totalIncome;
    },
    calculateWBS() {
      const persons = this.persons;
      const wbsService = new WbsService();
      wbsService.calculateWbs(persons).then(wbsErg => {
        this.wbsResult = true;
        this.wbs = wbsErg;
      });
    }
  },
  computed: {
    // Implement any necessary computed properties
  },
});
</script>

<template>
  <div class="App" id="div_app">
    <h1 id="ueberschrift">WBS Rechner</h1>
    <Headerbox title="Haushaltsmitglieder">
      <div class="label-container">
        <label for="personenanzahl">Anzahl Personen im Haushalt</label>
        <input v-model="personanzahl" id="personenanzahl" type="number" min="1" max="20"
          @input="updatePersonenanzahl" />
      </div>
    </Headerbox>
    <div v-for="(person, pindex) in persons" :key="pindex">
      <Headerbox :title="'Daten der ' + person.index + '. Person'">
        <div>
          <div v-for="(income, inindex) in person.incomes" :key="inindex" class="label_box">
            <div class="label-container">
              <label :for="'number_' + person.index + '_' + inindex">Einkommen Nummer</label>
              <input :id="'amount_' + person.index + '_' + inindex" type="number" disabled :value="inindex+1">
            </div>
            <div class="label-container">
              <label :for="'type_' + person.index + '_' + inindex">Typ</label>
              <select :id="'type_' + person.index + '_' + inindex" v-model="income.type">
                <option :value="0" disabled>keine Auswahl</option>
                <option v-for="type in types" :key="type.value" :value="type.value">{{ type.description }}</option>
              </select>
            </div>
            <div class="label-container">
              <label :for="'frequency_' + person.index + '_' + inindex">Frequenz</label>
              <select :id="'frequency_' + person.index + '_' + inindex" v-model="income.frequency"
                @change="calculateTotalIncome(pindex)">
                <option :value="0" disabled>keine Auswahl</option>
                <option v-for="freq in freq" :key="freq.value" :value="freq.value">{{ freq.description }}</option>
              </select>
            </div>
            <div class="label-container">
              <label :for="'amount_' + person.index + '_' + inindex">Brutto Betrag</label>
              <input :id="'amount_' + person.index + '_' + inindex" type="number" v-model="income.amount" min="0"
                @input="calculateTotalIncome(pindex)" />
            </div>
            <div class="label-container">
              <label :for="'advertisingCosts_' + person.index + '_' + inindex">jährliche Werbungskosten</label>
              <input :id="'advertisingCosts_' + person.index + '_' + inindex" type="number"
                v-model="income.advertisingCosts" min="0" @input="calculateTotalIncome(pindex)" />
            </div>
            <div class="label-container">
              <label :for="'delete_' + person.index + '_' + inindex">Löschen</label>
              <button class="delete-button" :id="'delete_' + person.index + '_' + inindex"
                @click="deleteIncome(pindex, inindex)"
                :title="(inindex + 1) + ' Einkommen der ' + person.index + ' Person löschen'">&times; Löschen</button>
            </div>
          </div>

          <button @click="addIncome(person.index)" class="calculateButton">+ Einkommen hinzufügen</button>
        </div>
      </Headerbox>
    </div>
    <Headerbox title="WBS berechnen">
      <h2>Zusammenfassung Haushalt</h2>
      <div v-for="p in persons" :key="p.index" class="label_box">
        <div class="label-container">
          <label :for="'nr' + p.index">Nr.</label>
          <span :id="'nr' + p.index">{{ p.index }}</span>
        </div>

        <div class="label-container">
          <label :for="'kindsalter' + p.index">Kindsalter</label>
          <span :id="'kindsalter' + p.index">N/A</span>
        </div>

        <div class="label-container">
          <label :for="'freibetrage' + p.index">Freibeträge</label>
          <span :id="'freibetrage' + p.index">N/A</span>
        </div>

        <div class="label-container">
          <label :for="'gesamteinkommen' + p.index">Gesamteinkommen</label>
          <span :id="'gesamteinkommen' + p.index">{{ p.totalincome }}</span>
        </div>
      </div>
      <button @click="calculateWBS" class="calculateButton">⚙ WBS berechnen</button>

      <div v-if="wbsResult">
        <div class="label-container">
          <label for="yearlyAmount">anrechenbares jährliches Gesamteinkommen:</label>
          <span id="yearlyAmount">{{ wbs.yearlyAmount }} €</span>
        </div>
        <div class="label-container">
          <label for="yearlyAmountMax">Einkommensgrenze:</label>
          <span id="yearlyAmountMax">{{ wbs.yearlyAmountMax }} €</span>
        </div>
        <div class="label-container">
          <label for="difference">{{ wbs.difference > 0 ? 'Überschreitung' : 'Unterschreitung' }}</label>
          <span id="difference">{{ wbs.difference }} €</span>
        </div>
        <div class="label-container">
          <label for="percent">Verhältnis Gesamteinkommen / Einkommensgrenze</label>
          <span id="percent">{{ wbs.percent }} %</span>
        </div>
        <div class="label-container">
          <label for="wbsGranted">Möglicher WBS:</label>
          <span id="wbsGranted">{{ wbs.wbsGranted }}</span>
        </div>
      </div>
    </Headerbox>
  </div>
</template>
